export const YEREVAN_CENTER_LOCATION = {
  lat: 40.18442318047865,
  lng: 44.50683723412691,
};

export const EMPTY_OBJECT = {};

const {
  DEV: IS_DEVELOPMENT_ENVIRONMENT,
  VITE_API_URL,
  VITE_X_ORG_DOMAIN,
} = import.meta.env;

export { IS_DEVELOPMENT_ENVIRONMENT, VITE_API_URL, VITE_X_ORG_DOMAIN };
